import { useEffect } from "react";
import axios from "axios";
import { API } from "./vikas";

// Board beacon: short codes only, batched, silent on every failure.
const CODE = /^[A-Za-z][A-Za-z0-9_.:-]*$/;
const MAX_BATCH = 50;
let queue = [];
let pass = null; // {url, pass, exp}
let lastTap = null;
const opened = new Set();

const code = (v, max = 40) => {
  if (typeof v !== "string") return null;
  return v.length <= max && CODE.test(v) && !/\d{5}/.test(v) ? v : null;
};
export const pressCode = (action) => {
  const a = String(action || "").trim().toLowerCase();
  return code(a === "vikas mistake" ? "mistake" : a.replace(/\s+/g, "_"));
};
export const markTap = () => { lastTap = performance.now(); };
const sinceTap = () => Math.round(performance.now() - (lastTap ?? 0));

export function beacon(kind, section, extra = {}) {
  const k = code(kind);
  const s = code(section);
  if (!k || !s) return;
  const e = { kind: k, section: s, at: new Date().toISOString() };
  const cid = code(extra.card_id, 80);
  const act = code(extra.action);
  const why = code(extra.reason);
  if (cid) e.card_id = cid;
  if (act) e.action = act;
  if (why) e.reason = why;
  if (Number.isFinite(extra.ms)) e.ms = Math.max(0, Math.round(extra.ms));
  queue.push(e);
  if (queue.length >= MAX_BATCH) flush();
}

// the first draw of a section in this page load; ms from the last tap (or page start)
export function opened1(section) {
  if (!section || opened.has(section)) return;
  opened.add(section);
  const ms = sinceTap();
  beacon("open", section, { ms });
  if (ms > 3000) beacon("slow", section, { ms });
}

export const useOpen = (section, on = true) => useEffect(() => { if (on) opened1(section); }, [section, on]);

export function tap(section, action, cardId) {
  markTap();
  beacon("tap", section, { action: action === "open_card" || action === "filter" ? action : pressCode(action), card_id: cardId });
}

async function getPass() {
  const now = Date.now() / 1000;
  if (pass && pass.exp - now > 300) return pass;
  try {
    const r = await axios.get(`${API}/beacon-pass`);
    pass = r.data && r.data.ready ? r.data : null;
  } catch { pass = null; }
  return pass;
}

async function send(batch, keepalive, retry) {
  const p = await getPass();
  if (!p) return;
  try {
    const res = await fetch(`${p.url}/event`, {
      method: "POST", keepalive,
      headers: { Authorization: `Bearer ${p.pass}`, "Content-Type": "application/json" },
      body: JSON.stringify({ events: batch }),
    });
    if (res.ok || [400, 401, 429].includes(res.status)) { if (res.status === 401) pass = null; return; }
    if (retry) await send(batch, keepalive, false);
  } catch {
    if (retry) await send(batch, keepalive, false);
  }
}

export function flush(keepalive = false) {
  if (!queue.length) return;
  const batch = queue.slice(0, MAX_BATCH);
  queue = queue.slice(MAX_BATCH);
  send(batch, keepalive, true).catch(() => {});
}

let started = false;
export function startBeacon() {
  if (started) return;
  started = true;
  getPass();
  setInterval(() => { flush(); if (pass) getPass(); }, 30000);
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") flush(true); });
  window.addEventListener("error", () => beacon("error", "board", { reason: "js" }));
  window.addEventListener("unhandledrejection", () => beacon("error", "board", { reason: "js" }));
}
